/**
 * Kcal picker — przełączanie kaloryczności na stronie diety
 * aktualizuje wyświetlaną cenę regularną i cenę powyżej 5 dni.
 * Markup: woocommerce/single-product.php
 */

const ACTIVE = ["bg-obsidian", "text-sunburst"];
const IDLE = ["bg-white", "text-obsidian", "hover:bg-obsidian/10"];

function setState(button, isActive) {
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.classList.remove(...(isActive ? IDLE : ACTIVE));
    button.classList.add(...(isActive ? ACTIVE : IDLE));
}

function init() {
    const pickers = document.querySelectorAll("[data-kcal-picker]");
    if (!pickers.length) return;

    pickers.forEach((picker) => {
        const options = picker.querySelectorAll("[data-kcal-option]");
        const regularOut = picker.querySelector("[data-kcal-regular]");
        const aboveOut = picker.querySelector("[data-kcal-above]");

        if (!options.length || !regularOut || !aboveOut) return;

        options.forEach((option) => {
            option.addEventListener("click", () => {
                options.forEach((other) => setState(other, other === option));

                regularOut.textContent = `${option.dataset.regular} zł`;
                aboveOut.textContent = `${option.dataset.above} zł`;
            });
        });
    });
}

export default {init};
